/* eslint-disable */

import blub from '../../assets/SVGS/blub.svg'

import { Button } from '../../Components/ui/button'
import { useEffect, useRef, useState } from 'react'
import PaymentGif from '../../assets/gifs/https___lottiefiles.com_animations_flow-tWbpYsXrBz.gif'
import { useLocation, useNavigate } from 'react-router-dom'
import { AccountBalance } from '@mui/icons-material'
import env from '../../env/env'
import { Progress } from '../../Components/ui/progress'
import { usePaymentProcessingTimer } from '../../hooks/useProcessingTimer'
import { post } from '../../http/restservice'
import { useModal } from '../../hooks/use-modal-store'
import { useErrorPopup } from '../../hooks/useErrorPopup'
import { UserDetails } from '../../store/AccountDetailsStore'
import { useRecoilValueLoadable } from 'recoil'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../../Components/ui/accordian'

const MFMandatePage = () => {
  const location = useLocation()
  const [timeLeft, setTimeLeft] = useState(120)
  const [src, setSrc] = useState('')
  const handleError = () => {
    setSrc(null)
  }

  const openExternalWindow = (url) => {
    if (!url) return

    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) {
      newWindow.opener = null
    }
  }

  const hasOpened = useRef(false)
  const { state, contents: bankDetails } = useRecoilValueLoadable(UserDetails)
  const { progress } = usePaymentProcessingTimer(600) // 5 minutes
  const [dots, setDots] = useState('')
  const [urlGenerated, setUrlGenerated] = useState('')
  const { onOpen } = useModal()
  const { showError } = useErrorPopup()
  const [mandateStatus, setMandateStatus] = useState('')
  const storedData = JSON.parse(localStorage.getItem('selectedActionPlans'))

  const navigate = useNavigate()

  //Simulate Mandate Success FLow
  // useEffect(() => {
  //   const oneTimePlans = storedData?.filter((plan) => plan?.oneTimeStatus === 'PENDING')
  //   console.log('🚀 ~ MFMandatePage ~ oneTimePlans:', oneTimePlans)

  //   onOpen('openActionPlanPopup', {
  //     severity: 'sipsuccess',
  //     title: '',
  //     message: oneTimePlans?.length
  //       ? 'Your SIP has been registered successfully. Please continue to complete your one-time investment.'
  //       : 'Your SIP order has been placed successfully. The transaction has been processed, and your investment will be scheduled accordingly.',
  //     redirectTo: oneTimePlans?.length ? '/dashboard/firstTime/actionPlanUser' : '/dashboard',
  //     goBack: '/dashboard',
  //   })
  // }, [])

  // useEffect(() => {
  //   onOpen('openMandatePopup', {
  //     title: <>Please try again</>,
  //     message:
  //       <>Your mandate setup could not be completed.

  //       </>,
  //     severity: 'info',
  //     closeButton: true,
  //     redirectBackTo: '/dashboard/firstTime/actionPlanUser',
  //     forwardTo: '/dashboard/firstTime/actionPlanUser',
  //     showExploreButton: true,
  //     exploreButtonText: 'Try Again',
  //   })
  // }, [])

  useEffect(() => {
    const handlePolling = async () => {
      if (location?.state?.mandateId) {
        // Check if it's time to call the eMandateAuthURL
        if (timeLeft % 10 === 0 || timeLeft === 0) {
          try {
            const eMandateResponse = await getEMandateAuthURL(location?.state?.mandateId)


            if (eMandateResponse.Status == 100) {
              setTimeLeft(-10)
              handleSuccessfulEMandate(eMandateResponse)
              return
            }


            if (timeLeft <= 0 && eMandateResponse.Status != 100) {
              handleFailedEMandate()
            }
          } catch (error) {
            console.error('Error in eMandateAuthURL:', error)
            handleFailedEMandate()
          }
        }

        // Countdown logic
        if (timeLeft > 0) {
          const timerId = setTimeout(() => {
            setTimeLeft((prevTime) => prevTime - 1)
          }, 1000)

          // Cleanup timeout
          return () => clearTimeout(timerId)
        }
      }
    }

    handlePolling() // Call the polling function
  }, [timeLeft])

  useEffect(() => {
    const startPolling = () => {
      const pollingDuration = 600 // Total duration in seconds (10 minutes)
      const pollingInterval = 10 // Interval in seconds
      let timeLeft = pollingDuration

      // Start the polling
      const intervalId = setInterval(async () => {
        if (timeLeft <= 0) {
          // Stop polling after 10 minutes
          onOpen('openMandatePopup', {
            title: <>Please try again</>,
            message:
              <>Your mandate setup could not be completed.

              </>,
            severity: 'info',
            closeButton: true,
            redirectBackTo: '/dashboard/firstTime/actionPlanUser',
            forwardTo: '/dashboard/firstTime/actionPlanUser',
            showExploreButton: true,
            exploreButtonText: 'Try Again',
          })
          clearInterval(intervalId)
          return
        }

        // Execute polling logic at each 10-second interval
        try {
          const response = await getMandateDeatils(location?.state?.mandateId)

          console.log('🚀 ~ getMandateDeatils ~ response:', response, timeLeft)



          if (response?.MandateDetails[0]?.status) {
            setMandateStatus(response?.MandateDetails[0]?.status)
          }

          if (
            location?.state?.isStandaloneMandate &&
            !response.isError &&
            (response.MandateDetails[0].status === 'UNDER PROCESSING' ||
              response.MandateDetails[0].status === 'APPROVED' ||
              response.MandateDetails[0].status === 'RECEIVED BY EXCHANGE')
          ) {


            onOpen('openMandatePopup', {
              title: <>Congrats! 🎉 <br /> Your mandate setup is now in progress.</>,
              message:
                <>The approval process usually takes 1–2 working days. <br /> You can track the status anytime under Mandates.
                </>,
              severity: 'success',
              closeButton: true,
              redirectBackTo: '/dashboard',
              forwardTo: '/dashboard/mandates',
              showExploreButton: true,
              exploreButtonText: 'View All Mandates',
            })
            clearInterval(intervalId) // Stop polling on success
            return
          }

          if (response.isError) {

            onOpen('openMandatePopup', {
              title: <>Please try again</>,
              message:
                <>Your mandate setup could not be completed.

                </>,
              severity: 'info',
              closeButton: true,
              redirectBackTo: '/dashboard/firstTime/actionPlanUser',
              forwardTo: '/dashboard/firstTime/actionPlanUser',
              showExploreButton: true,
              exploreButtonText: 'Try Again',
            })

            clearInterval(intervalId) // Stop polling on error
            return
          }

          if (
            !response.isError &&
            (response.MandateDetails[0].status === 'UNDER PROCESSING' ||
              response.MandateDetails[0].status === 'APPROVED' ||
              response.MandateDetails[0].status === 'RECEIVED BY EXCHANGE')
          ) {
            // RECEIVED BY EXCHANGE
            setUrlGenerated('')

            // isIndividual: false,
            // isBasketOrder: false,
            // isActionPlan: true,
            const { isIndividual, isActionPlan, isBasketOrder } = location?.state || {}
            const sipData = JSON.parse(sessionStorage.getItem('userSIPs')) || {}

            if (isIndividual && !isActionPlan && !isBasketOrder) {
              const handleSipRegistration = await handleXSIPIndividual(sipData.sip)
            } else if (!isIndividual && isActionPlan && !isBasketOrder) {
              const handleSipRegistration =
                sipData?.sip?.length && (await handleXSipRegistration(sipData.sip))

              if (sipData?.sip?.length && handleSipRegistration?.status === 'SUCCESS') {
                const oneTimePlans = storedData?.filter((plan) => plan?.oneTimeStatus === 'PENDING')

                oneTimePlans?.length
                  ? localStorage.setItem('selectedActionPlans', JSON.stringify(oneTimePlans))
                  : localStorage.removeItem('selectedActionPlans')

                onOpen('openActionPlanPopup', {
                  severity: 'sipsuccess',
                  title: '',
                  message: oneTimePlans?.length
                    ? 'Your SIP has been registered successfully. Please continue to complete your one-time investment.'
                    : 'Your SIP order has been placed successfully. The transaction has been processed, and your investment will be scheduled accordingly.',
                  redirectTo: oneTimePlans?.length
                    ? '/dashboard/firstTime/actionPlanUser'
                    : '/dashboard',
                  goBack: '/dashboard',
                })
              }
            } else {
              const handleSipRegistration = await handleXSIPBasket(sipData.sip)
            }

            clearInterval(intervalId) // Stop polling on success
            return
          }

        } catch (error) {
          console.error('Error in eMandateAuthURL:', error)
          handleFailedEMandate()
          clearInterval(intervalId) // Stop polling on error
          return
        }

        // Decrease time left
        timeLeft -= pollingInterval
      }, pollingInterval * 1000) // Convert interval to milliseconds

      return intervalId // Return interval ID for cleanup
    }

    let intervalId
    if (urlGenerated) {
      intervalId = startPolling(urlGenerated)
    }

    // Cleanup function to clear interval on unmount
    return () => {
      if (intervalId) {
        clearInterval(intervalId)
      }
    }
  }, [urlGenerated])

  const handleSuccessfulEMandate = (eMandateResponse) => {

    if (!urlGenerated && !hasOpened.current) {
      hasOpened.current = true
      setUrlGenerated(eMandateResponse.ResponseString)
      // window.location.href = eMandateResponse.ResponseString
      openExternalWindow(eMandateResponse.ResponseString)
    }
  }

  // Helper function to handle failed eMandate response
  const handleFailedEMandate = () => {
    onOpen('openMandatePopup', {
      title: <>Please try again</>,
      message:
        <>Your mandate setup could not be completed.

        </>,
      severity: 'info',
      closeButton: true,
      redirectBackTo: '/dashboard/firstTime/actionPlanUser',
      forwardTo: '/dashboard/firstTime/actionPlanUser',
      showExploreButton: true,
      exploreButtonText: 'Try Again',
    })
  }

  const getEMandateAuthURL = async () => {
    const eMandatePayload = {
      clientCode: location?.state?.clientCode,
      mandateId: location?.state?.mandateId,
      loopBackUrl: `${env.LOOPBACK_URL}dashboard/mutual-funds/mandate`,
    }

    const response = await post(
      'mutualfundservice/api/bseStar/mfWebService/eMandateAuthURL',
      eMandatePayload,
    )

    if (response.isError) {
      onOpen('openMandatePopup', {
        title: <>Please try again</>,
        message:
          <>Your mandate setup could not be completed.

          </>,
        severity: 'info',
        closeButton: true,
        redirectBackTo: '/dashboard/firstTime/actionPlanUser',
        forwardTo: '/dashboard/firstTime/actionPlanUser',
        showExploreButton: true,
        exploreButtonText: 'Try Again',
      })

      return
    }

    return response
  }

  const getMandateDeatils = async () => {
    const today = new Date()
    const formattedDate = today.toLocaleDateString('en-GB').replace(/\//g, '/')

    const payload = {
      fromDate: '01/10/2024',
      toDate: formattedDate,
      clientCode: location?.state?.clientCode,
      mandateId: location?.state?.mandateId,
    }

    const response = await post(
      'mutualfundservice/api/bseStar/mfWebService/mandateDetails',
      payload,
    )


    if (response?.isError) {
      onOpen('openMandatePopup', {
        title: <>Please try again</>,
        message:
          <>Your mandate setup could not be completed.

          </>,
        severity: 'info',
        closeButton: true,
        redirectBackTo: '/dashboard/firstTime/actionPlanUser',
        forwardTo: '/dashboard/firstTime/actionPlanUser',
        showExploreButton: true,
        exploreButtonText: 'Try Again',
      })
    }

    return response
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prevDots) => {
        if (prevDots === '...') return '.'
        return prevDots + '.'
      })
    }, 500) // Change dot every 500ms

    return () => clearInterval(interval)
  }, [])

  let ifscCode = bankDetails?.ifscCode
  const extractedBranch = ifscCode?.match(/^[A-Za-z]{4}/)?.[0]?.toLowerCase()
  const iconSrc = `${env.BANK_LOGOS}/${extractedBranch}/symbol.svg`

  useEffect(() => {
    setSrc(iconSrc)
  }, [iconSrc])

  const handleXSipRegistration = async (payload) => {
    try {
      const xSIPRegistration = await post(
        'mutualfundservice/api/illusion/multiBasketSipRegistrationOrder',
        payload,
      )

      if (xSIPRegistration?.isError) {
        showError(
          'SIPs Registration Failed',
          'We encountered an issue while registering your SIP. Please try again or contact support for assistance.',
          () => { },
        )
        return
      }

      if (xSIPRegistration.status === 'SUCCESS') {
        return xSIPRegistration
      }
    } catch (error) {
      console.log('Error registering XSIP:', error)
    }
  }

  const handleXSIPIndividual = async () => {
    const payload = location?.state?.sip || JSON.parse(sessionStorage.getItem('userSIPs'))?.sip

    try {
      const xSIPRegistration = await post(
        'mutualfundservice/api/illusion/sipRegistrationOrder',
        payload,
      )

      if (xSIPRegistration?.isError) {
        showError(
          'SIPs Registration Failed',
          'We encountered an issue while registering your SIP. Please try again or contact support for assistance.',
          () => { },
        )
        return
      }

      if (
        xSIPRegistration.status === 'SUCCESS' &&
        xSIPRegistration?.data?.orderStatus === 'ACTIVE'
      ) {
        onOpen('openPopup', {
          title: 'SIP Registration Successful! ',
          message:
            'SIP Registration Successful! 🎉 Your SIP registration has been completed successfully.',
          severity: 'success',
        })
      }
    } catch (error) {
      console.log('Error registering XSIP:', error)
    }
  }

  const handleXSIPBasket = async () => {
    const payload = location?.state?.sip || JSON.parse(sessionStorage.getItem('userSIPs'))?.sip

    try {
      const xSIPRegistration = await post(
        'mutualfundservice/api/illusion/basketSipRegistrationOrder',
        payload,
      )

      if (xSIPRegistration?.isError) {
        showError(
          'SIPs Registration Failed',
          'We encountered an issue while registering your SIP. Please try again or contact support for assistance.',
          () => { },
        )
        return
      }

      if (
        xSIPRegistration.status === 'SUCCESS' &&
        xSIPRegistration?.data?.orderStatus === 'ACTIVE'
      ) {
        onOpen('openBasketPopup', {
          title: 'SIPs Registered Successfully! 🎉',
          message:
            'Your SIPs have been successfully registered. Please note that processing will take 3-4 working days.',
          severity: 'sipsuccess',
        })
      }
    } catch (error) {
      console.log('Error registering XSIP:', error)
    }
  }

  return (
    <div className='bg-white fixed top-0 left-0 right-0 bottom-0 z-[1000] overflow-y-scroll lg:py-4'>
      <div className='ease-in-out h-screen md:max-w-md m-auto flex flex-col justify-center gap-y-4 px-4 py-2 md:py-0'>
        <div className='flex flex-col gap-y-6'>
          <div>
            <h2 className='text-center text-xl md:text-2xl text-black-500 font-semibold'>
              Taking you to create mandate on your bank’s website
            </h2>
            <p className='text-center text-sm text-black-400 mt-2 animate-pulse'>
              Please do not close tab or go back while the process is in progress.
            </p>
          </div>
          <div className='relative flex justify-between items-center px-4 bg-primary-50 py-2 rounded-2xl h-12 md:h-16'>
            <img src={`${env.SVGS}/logo.svg`} alt='UPI Icon' />
            <img
              src={PaymentGif}
              alt='Moving GIF'
              className='absolute left-[25.51%] move-left-right rotate-90 z-2'
            />
            {/* Add the bank icon here */}
            {src ? (
              <img src={src} alt='bank logos' onError={handleError} height={24} width={24} />
            ) : (
              <AccountBalance className='text-primary-600' />
            )}
          </div>

          <div className='relative'>
            <video
              className='w-full aspect-video rounded-2xl'
              controls
              playsInline
              preload='metadata'
            >
              <source
                src='https://d3lgi69rk7563.cloudfront.net/ProductVideos/Mandate.mp4'
                type='video/mp4'
              />
              Your browser does not support the video tag.
            </video>
          </div>

          <div>
            {/* <div className='flex gap-x-2 items-center'>
                <img src={blub} alt={'Blub'} className='h-6 w-6 md:h-auto md:w-auto' />
                <h2 className='font-semibold text-sm md:text-base'>What is a mandate?</h2>
              </div> */}

            <Accordion type='single' collapsible className='w-full'>
              <AccordionItem value='item-1' className='border rounded-lg'>
                <AccordionTrigger className='px-4'>
                  Important notes about your SIP mandate
                </AccordionTrigger>
                <AccordionContent className='px-4 pb-4'>
                  <ol className='space-y-4 list-disc text-xs md:text-sm px-5 text-black-400'>
                    <li>
                      Mandate is <strong>maximum amount </strong>
                      that BSE is permitted to deduct from your account
                    </li>
                    <li>
                      The mandate amount may be more than your desired SIP amount, to account for
                      future changes in your investment plans.
                    </li>
                  </ol>
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>
        </div>

        {/* {(mandateStatus == 'RECEIVED BY EXCHANGE' || mandateStatus == 'UNDER PROCESSING') && ( */}
        {urlGenerated && (
          <div className='flex flex-col gap-y-2'>
            <Progress value={progress} className='h-2 bg-primary-100' />
            <p className='text-sm text-center'>
              Processing mandate… Please don’t close the app or go back.
            </p>
          </div>
        )}
        {/* )} */}

        {(mandateStatus != 'RECEIVED BY EXCHANGE' || mandateStatus != 'UNDER PROCESSING') && (
          <div className='flex justify-between gap-x-4'>
            <Button
              disabled={!urlGenerated}
              onClick={() => openExternalWindow(urlGenerated)}
              className='flex-1 rounded-lg bg-primary-600 hover:bg-primary-500 disabled:bg-primary-200 text-wrap'
            >
              {!urlGenerated ? `Redirecting you to mandate page${dots}` : 'Continue'}
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}

export default MFMandatePage
